import React from 'react';
import logo from "/images/logo.png";
import "../../Styles/style.css";

const LogoLoader = () => {
    return (
        <div className="logo-loader-container">
            <div className="logo-loader-wrapper">
                <div className="logo-loader-ring"></div>
                <img src={logo} alt="Loading..." className="logo-loader-img" />
            </div>
            <p className="mt-3 text-muted fw-bold" style={{ color: '#139956', letterSpacing: '1px' }}>Please Wait...</p>
        </div>
    );
};

export default LogoLoader;
